'use strict';

export { startWebLayoutAnimation, tryActivateLayoutTransition } from './animationsManager';
export { getReducedMotionFromConfig, saveSnapshot } from './componentUtils';
export { configureWebLayoutAnimations } from './domUtils';
//# sourceMappingURL=index.js.map